import { AffinityGroup } from './affinity-group.model';

export class Producer {
    code: string;
    branchOffice: number;
    firstName: string;
    lastName: string;
    name: string;
    producerName?: string;
    number: number;
    organizerNumber: number;
    organizer?: any;
    cuit?: string;
    affinityGroup?: AffinityGroup;
    typeCode?: {
        code: string,
        description: string
    };
    fullName?: string;
    organization?: Producer;
    channelCommercial?: {
        code: string,
        description: string
    }

    constructor(data: Partial<Producer> = {}) {
        Object.assign(this, data);
    }

    getFullNumber?(): string {
        if (!(this.branchOffice && this.number)) {
            return '';
        }

        return `${String(this.branchOffice).padStart(2, '0')}-${String(this.number).padStart(6, '0')}`;
    }

    getFullName?(): string {
        if (this.name && this.name.length) {
            return this.name;
        }

        if (this.firstName && this.lastName && this.firstName.length && this.lastName.length) {
            return `${this.firstName} ${this.lastName}`;
        }
    }
}
